export default "__VITE_ASSET__B6wRjfvT__"